angular.module('app').directive('dayOnly', function() {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: function (scope, elem, attrs, ngModel) {
            var toView = function (val) {
                if(!val) {
                    return val;
                }
                return moment(val).toDate();
            };

            ngModel.$formatters.push(toView);
        }
    };
});
